// src/pages/dashboard/Dashboard.tsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

const Dashboard: React.FC = () => {
  const { user } = useAuth();
  
  // Redirect to role-specific dashboard
  if (user) {
    return <Navigate to={`/${user.role}`} replace />;
  }
  
  return <Navigate to="/login" replace />;
};

export default Dashboard;